import { useTranslation } from 'react-i18next';
import { PageHeading } from '@hp/ui';
import { useCan } from '../api/me';
import { useMergeJobs } from '../features/jobs/queries';
import { ErrorAlert } from '../components/error-alert';
import { JobTable } from '../features/jobs/job-table';
import { NewJobPanel } from '../features/jobs/new-job-panel';

export default function Jobs() {
  const { t } = useTranslation(['jobs', 'common']);
  const can = useCan();
  const jobs = useMergeJobs();

  return (
    <div className="bo-sections">
      <PageHeading title={t('title')} description={t('description')} />

      {can('crm.merge') && <NewJobPanel />}

      <ErrorAlert error={jobs.error} />

      <JobTable jobs={jobs.data ?? []} isLoading={jobs.isLoading} />
    </div>
  );
}
